# The template of the six lessons: a title, an optional progress marker and one Explanation block.
Template (@stxt.template): stxt.play.tutorial
	Structure >>
		Lesson:
			Progress: (?)
			Explanation: (1) TEXT
